import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { SharedHttp } from "../../services/http-client.service";
import { WebClientService } from "../../services/webclient-settings.service";
import { UtilityService } from "../../services/utility.service";
let Crypto2cryptoComponent = class Crypto2cryptoComponent {
    constructor(sanitizer, themeService, httpClient, webSettingsService, utilityService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.utilityService = utilityService;
        this.errorColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.inputBackColor = '';
        this.textColor = '';
        this.linkColor = '';
        this.mainColor = '';
        this.successColor = '';
        this.activeFromEcurrency = false;
        this.activeToEcurrency = false;
        this.activeCurrency = localStorage.getItem('defaultCurrency').toLowerCase();
        this.address = '';
        this.fee = '';
        this.validDepositAddress = true;
        this.acceptTermsAndConditions = false;
        this.acceptOwnNameAndAccount = false;
        this.validCheckboxes = false;
        this.defaultDecimalPlaces = 8;
        this.isFormValid = false;
        this.requestSubmitted = false;
        this.requestFinished = false;
        this.requestSuccessful = false;
        this.themeService.getTheme().subscribe((data) => {
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
        });
        this.webSettingsService.getSettings().subscribe((data) => {
            this.fee = this.webSettingsService.getWebSetting('CRYPTO2CRYPTO_FEE_PERCENT');
        });
        this.httpClient.get('wallet/getallcurrencies').subscribe((data) => {
            this.ecurrencies = data['currencies'].filter(currency => currency.fiat === false);
        });
        this.httpClient.get('market/pricesforwallet').subscribe((data) => {
            this.prices = data;
        });
    }
    ngOnInit() {
    }
    openFromEcurrecies() {
        this.activeFromEcurrency = !this.activeFromEcurrency;
        this.activeToEcurrency = false;
    }
    openToEcurrecies() {
        this.activeToEcurrency = !this.activeToEcurrency;
        this.activeFromEcurrency = false;
    }
    fillFromCurrency(value) {
        this.fromEcurrency = value;
        this.activeFromEcurrency = false;
        this.calculateAmount();
        this.validateForm();
    }
    fillToCurrency(value) {
        this.toEcurrency = value;
        this.activeToEcurrency = false;
        this.validateAddress();
        this.calculateAmount();
        this.validateForm();
    }
    checkIfCurrenciesAreSame() {
        return this.fromEcurrency && this.toEcurrency && this.fromEcurrency.verboseId === this.toEcurrency.verboseId;
    }
    validateAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.toEcurrency && this.webSettingsService.applySettings('ADDRESS_VALIDATION')) {
                yield this.utilityService.validateAddress(this.address, this.toEcurrency.verboseId).then(result => {
                    this.validDepositAddress = result.validDepositAddress;
                });
            }
            else {
                this.validDepositAddress = true;
            }
            return this.validDepositAddress;
        });
    }
    checkedBox(e) {
        this.validCheckboxes = this.acceptTermsAndConditions && this.acceptOwnNameAndAccount;
        this.validateForm();
    }
    validateForm() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isFormValid = this.fromEcurrency && this.toEcurrency && !this.checkIfCurrenciesAreSame() && this.amount && this.amountReceive &&
                this.address && (yield this.validateAddress()) && this.acceptOwnNameAndAccount && this.acceptTermsAndConditions;
            return this.isFormValid;
        });
    }
    calculateAmount() {
        if (this.amount && this.fromEcurrency && this.toEcurrency) {
            const fromCurrencyPrice = Number(this.prices[this.activeCurrency + '_prices'][this.fromEcurrency.verboseId.toLowerCase()]);
            const toCurrencyPrice = Number(this.prices[this.activeCurrency + '_prices'][this.toEcurrency.verboseId.toLowerCase()]);
            if (fromCurrencyPrice && toCurrencyPrice) {
                const sellValue = this.amount * fromCurrencyPrice;
                const fee = sellValue * (Number(this.fee) / 100);
                const availableFunds = sellValue - fee;
                const amountToBuy = availableFunds / toCurrencyPrice;
                this.amountReceive = this.utilityService.truncateDataBasedOnPrecision(amountToBuy, this.defaultDecimalPlaces);
            }
        }
    }
    initiateCrypto2Crypto() {
        if (this.validateForm()) {
            const data = {
                from_currency: this.fromEcurrency.verboseId,
                to_currency: this.toEcurrency.verboseId,
                amount: this.amount,
                destination_address: this.address,
                amount_received: this.amountReceive,
            };
            this.requestSubmitted = true;
            this.httpClient.post('crypto2crypto/createrequest', data).subscribe(result => {
                this.requestFinished = true;
                this.requestSuccessful = true;
            }, error => {
                this.requestSuccessful = false;
                this.requestFinished = true;
            });
        }
    }
};
Crypto2cryptoComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp },
    { type: WebClientService },
    { type: UtilityService }
];
Crypto2cryptoComponent = __decorate([
    Component({
        selector: 'ecd-crypto2crypto',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./crypto2crypto.component.html")).default,
    })
], Crypto2cryptoComponent);
export { Crypto2cryptoComponent };
